import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';

// Gate the Platform-Admin console (/admin/*). Mirrors the backend
// is_app_admin chokepoint (ADR 0002): only Platform Admins may enter.
// Non-admins (and signed-out users) are bounced to /chat. The backend
// re-checks every /admin/* call, so this is UX, not the security boundary.
export const adminGuard: CanActivateFn = () => {
    const auth = inject(AuthService);
    const router = inject(Router);

    if (auth.isAuthenticated() && auth.state().user?.is_app_admin) {
        return true;
    }

    return router.createUrlTree(['/chat']);
};
